export default {
    statusActions: {
        validate: 'Validate',
        approve: 'Approve',
        revertToDraft: 'Revert to draft',
        lock: 'Lock',
        unlock: 'Unlock',
        statusChangedTitle: 'Status → {target}',
        transitionRejectedTitle: 'Transition rejected',
        transitionRejectedMessage: 'transition rejected',
        transitionFailedMessage: 'transition failed',
    },
}
